import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthenticationService } from '../security/authentication.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'left-menu',
  templateUrl: './left-menu.component.html'
})
export class LeftMenuComponent {

  @Output() onCloseLeftMenu = new EventEmitter(); 

  constructor(private authenticationService: AuthenticationService) { }

  public displayOnlyForDairy(): boolean {
    let currentUserType = this.authenticationService.getCurrentUser().thirdParty.type;

    return environment.dairyRoles.indexOf(currentUserType.code) >= 0;
  }

  public closeMenu(): void{
    this.onCloseLeftMenu.emit();
  }
}


// WEBPACK FOOTER //
// ./src/app/left-menu/left-menu.component.ts